
/* injects from baggage-loader */
require('./style.styl');

import React, {Children, cloneElement} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class Legend extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    inline: PropTypes.bool,
    align: PropTypes.oneOf(['right'])
  }

  render() {
    const {inline, align, className} = this.props
    const classNames = classnames(className, 'legend', {
      'is-inline': inline,
      'is-align-right': align === 'right'
    })
    return (
      <div className={classNames}>
        {Children.map(this.props.children, child => {
          if (!child) return null

          return cloneElement(child, {
            className: classnames(child.props.className, 'legend_item')
          })
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Legend/index.js